let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("37Dgy")).then(() => parcelRequire('jD1kq'));